export function getShortLocationLabel(location: string): string {
    if (!location) return location;
    // Add more patterns as needed
    const patterns: { regex: RegExp; label: string }[] = [
      { regex: /bengaluru\s*\/\s*bangalore/i, label: "Bengaluru" },
      { regex: /hyderabad\s*\/\s*secunderabad.*telangana/i, label: "Hyderabad" },
      { regex: /gurgaon\s*\/\s*gurugram/i, label: "Gurugram" },
    ];
  
    for (const { regex, label } of patterns) {
      if (regex.test(location)) {
        return label;
      }
    }
    return location;
}